import { render, staticRenderFns } from "./HomeContracts.vue?vue&type=template&id=245bb677&"
import script from "./HomeContracts.vue?vue&type=script&lang=js&"
export * from "./HomeContracts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports